import script from "./FilteredCoeComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FilteredCoeComponent.vue?vue&type=script&setup=true&lang=js"

import "./FilteredCoeComponent.vue?vue&type=style&index=0&id=02b37a53&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b37a53"]])

export default __exports__